export default "__VITE_ASSET__B$M7$Y7t__"